export default proposal => {
  let resultProperty = null

  try {
    resultProperty = proposal()
  } catch (e) {}

  return resultProperty
}
